export default __webpack_public_path__ + "static/Calibre-Semibold-0208f194a01d73daec7a4d915b641a1e.ttf";